module.exports = __webpack_public_path__ + "static/media/p5_8.e806b6d9.jpeg";